import { SwapsHeader } from './SwapsHeader'
import { SwapsTable } from './SwapsTable'
import { type FilterStatus } from './TransactionsHeader'
import { type SwapData } from './types'

export interface SwapsTabViewProps {
  swaps: SwapData[]
  loading?: boolean
  title?: string
  showExportButton?: boolean
  showApproveButton?: boolean
  showRejectButton?: boolean
  showFlagButton?: boolean
  isComplianceUser?: boolean

  // Callbacks
  onApproveSwap?: (swapId: string) => Promise<void>
  onRejectSwap?: (swapId: string, reason: string) => Promise<void>
  onFlagSwap?: (swapId: string, flagged: boolean) => Promise<void>
  onViewSwapDetails?: (swapId: string) => void
  onExportToCSV?: () => void
  onRefresh?: () => void
  isRefreshing?: boolean
  showRefreshButton?: boolean

  // Filter state (controlled by parent)
  selectedStatus?: string | null
  onStatusChange?: (status: FilterStatus | null) => void
  selectedFlag?: string | null
  onFlagChange?: (flag: string | null) => void
}

export function SwapsTabView({
  swaps,
  loading = false,
  title = 'Swaps',
  showExportButton = false,
  showApproveButton = false,
  showRejectButton = false,
  showFlagButton = false,
  showRefreshButton = false,
  isComplianceUser = false,
  onApproveSwap,
  onRejectSwap,
  onViewSwapDetails,
  onExportToCSV,
  onRefresh,
  isRefreshing = false,
  selectedStatus = null,
  onStatusChange,
  onFlagChange,
  selectedFlag,
}: SwapsTabViewProps) {
  return (
    <div className="space-y-4">
      <SwapsHeader
        title={title}
        showExportButton={showExportButton}
        showRefreshButton={showRefreshButton}
        selectedStatus={selectedStatus}
        onStatusChange={onStatusChange}
        onFlagChange={onFlagChange}
        selectedFlag={selectedFlag}
        onExportClick={onExportToCSV}
        onRefresh={onRefresh}
        isRefreshing={isRefreshing}
      />

      <SwapsTable
        swaps={swaps}
        loading={loading}
        showApproveButton={showApproveButton}
        showRejectButton={showRejectButton}
        showFlagButton={showFlagButton}
        isComplianceUser={isComplianceUser}
        onApproveSwap={onApproveSwap}
        onRejectSwap={onRejectSwap}
        onViewSwapDetails={onViewSwapDetails}
      />
    </div>
  )
}
